import { useSelector, EqualityFn } from "react-redux";
import { IState } from "./store.model";

// TODO vérifier les utilisations de useAppSelector pour voir si il n'y a pas trop de refresh
export const useAppSelector = <T,>(fn: (st: IState) => T, equalityFn?: EqualityFn<T>): T => {
    return useSelector<IState, T>(st => fn(st), equalityFn);
}
